import { render } from "./CInputTag.vue?vue&type=template&id=fda606a6"
import script from "./CInputTag.vue?vue&type=script&lang=js"
export * from "./CInputTag.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__